import { useIsAuthenticated } from "@refinedev/core";
import { Navigate } from "react-router-dom";
import * as React from "react";

export function AuthGuard({ children }: { children: React.ReactNode }) {
  const { data, isLoading } = useIsAuthenticated();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <p className="text-muted-foreground">加载中...</p>
      </div>
    );
  }

  if (!data?.authenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
